import React from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import { Box, Icon, Text } from "@chakra-ui/react";
import { SelectOptionAccessory } from "./select-option-accessory";
export function SelectOption({ isFocused, isSelected, isDisabled, label, accessory, itemProps, }) {
    let bg = "white";
    let color = "gray.800";
    if (isFocused) {
        bg = "gray.100";
    }
    if (isSelected) {
        bg = "brand.100";
        color = "brand.600";
    }
    if (isDisabled) {
        color = "gray.500";
    }
    return (React.createElement(Box, { bg: bg, color: color, px: 3, py: 2, display: "flex", alignItems: "center", outline: "none", ...itemProps },
        accessory && React.createElement(SelectOptionAccessory, { accessory: accessory }),
        React.createElement(Text, { as: "span", flex: "1", minWidth: 0, fontSize: "md", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", userSelect: "none", mr: 3 }, label),
        React.createElement(Box, { flex: "none", display: "flex", alignItems: "center", justifyContent: "center", opacity: isSelected ? 1 : 0, "aria-hidden": "true" },
            React.createElement(Icon, { as: CheckIcon, color: "brand.600", boxSize: 4 }))));
}
